import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { companyUsers } from './types';

import { requestCompanyUsersSuccess, requestCompanyUsersFailure } from './reducer';

const logger = new Logger('Saga:Company');

export function* requestCompanyUserSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.company.users', { entityId: action.entityId }),
    );

    yield put(requestCompanyUsersSuccess(action.entityId, response.data));
  } catch (error) {
    logger.error('Failed to request company users with the following error', error);
    yield put(requestCompanyUsersFailure(action.entityId, error));
  }
}

export default function* companySaga() {
  return yield all([takeLatest(companyUsers.request, requestCompanyUserSaga)]);
}
